import * as Net from 'util/Net';

export function createAgentFactory(name: string, description: string): Promise<{agentFactoryId: string}> {
  return Net.postJSONPromise({url: '/1/api/llm/agent-factories', data: {name, description}});
}
